<script setup>
definePage({ meta: { ...PageMeta.Invoices.Edit.Meta, pageTitle: 'Edit Invoice' } })

import { useRoute } from 'vue-router'
import { useEntityPageTitle } from '@/composables/useEntityPageTitle'
import { useInvoiceStore } from '@/@vxapp/Invoices/useInvoiceStore'
import InvoicesEditPage from '@/views/Previews/Invoices/InvoicesEditPage.vue'

const route = useRoute()
const invoiceStore = useInvoiceStore()

useEntityPageTitle({
  entityName: 'Edit Invoice',
  record: () => invoiceStore.invoice,
  recordGuid: invoice => invoice.invoiceGUID,
  identifier: invoice => invoice.id,
})

/* ** */
</script>

<template>
  <InvoicesEditPage :key="route.params.guid" />
</template>
